"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FlipCall = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FlipCall_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.578 6.874c-.68-2.709-2.946-4.66-5.578-4.66-1.916 0-3.63 1.026-4.689 2.633a.5.5 0 0 1-.835-.55C3.7 2.441 5.71 1.213 8 1.213c3.239 0 5.9 2.44 6.604 5.66h.97c.198 0 .351.092.406.257.05.152.003.326-.096.474v.002l-1.248 1.82c-.125.185-.3.29-.489.287-.188-.003-.36-.111-.483-.285l-.001-.002-1.265-1.819a.522.522 0 0 1-.087-.474c.059-.162.212-.26.414-.26h.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.667 5H6a.998.998 0 0 0-1 1c0 2.763 2.237 5 5 5h.03c.54-.003.97-.46.97-1v-.667a.667.667 0 0 0-.667-.666h-.585a.999.999 0 0 0-.707.293l-.27.27a.34.34 0 0 1-.24.1.308.308 0 0 1-.136-.032 3.675 3.675 0 0 1-1.693-1.693.33.33 0 0 1 .069-.376l.27-.27a1 1 0 0 0 .292-.706v-.586A.667.667 0 0 0 6.667 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.275 9.126h-.853c.68 2.709 2.946 4.66 5.578 4.66 1.916 0 3.63-1.026 4.689-2.633a.5.5 0 0 1 .835.55C12.3 13.559 10.29 14.787 8 14.787c-3.239 0-5.9-2.44-6.603-5.66h-.97c-.2 0-.352-.092-.407-.257-.05-.152-.003-.326.096-.474v-.002l1.248-1.82c.125-.185.3-.29.489-.287.188.003.36.111.483.285l.001.002 1.265 1.819a.522.522 0 0 1 .087.474c-.059.162-.212.26-.414.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FlipCall_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FlipCall;
exports["default"] = _default;